// schema
import * as ISchema from "@schema";

// libraries
import * as React from "react";

// chrome-day-all-day-events imports
import { IProps, IState } from "./ChromeDayAllDayEvents.d";
import { styles } from "./ChromeDayAllDayEvents.styles";
//components
import { CalendarDayEvent } from "@clockwise/web-commons/src/components/calendar";
// util
import { EventPositioner } from "@util/event-position.util";
import { BASE_HEIGHT } from "../ChromeDay.constants";
// material ui
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";

export class ChromeDayAllDayEvents extends React.Component<IProps, IState> {
  public static getDerivedStateFromProps(props: IProps, state?: IState): IState {
    const eventPositioners = props.events
      .map(({ event }) => new EventPositioner(event, [props.selectedMoment]))
      .sort((ep1, ep2) => {
        const title1 = ep1.event.title;
        const title2 = ep2.event.title;
        if (!title1 || !title2) {
          // Sort unnamed events (where title is null or '') to the end of the list
          return !title1 && !title2 ? 0 : !title1 ? 1 : -1;
        } else if (title1 === title2) {
          return 0;
        } else {
          return title1 > title2 ? -1 : 1;
        }
      });

    return {
      // FIXME: Don't cast
      eventPositioners: eventPositioners as EventPositioner<ISchema.IEvent>[],
      hasPourover: eventPositioners.length > 2,
      isPouroverExpanded: state ? state.isPouroverExpanded : true,
    };
  }

  constructor(props: IProps) {
    super(props);

    this.state = ChromeDayAllDayEvents.getDerivedStateFromProps(props);
  }

  private renderEvent = (eventPositioner: EventPositioner<ISchema.IEvent>) => {
    const { colorSettings, userId, calendarIds } = this.props;

    const height = BASE_HEIGHT / 2;

    return (
      <div style={{ ...styles.eventContainer, height }}>
        <CalendarDayEvent
          mode="standard"
          eventPositioner={eventPositioner}
          userId={userId}
          calendarIds={calendarIds}
          colorSettings={colorSettings}
          onClick={this.props.onDayEventClick}
        />
      </div>
    );
  };

  private togglePourover = () => {
    this.setState({
      isPouroverExpanded: !this.state.isPouroverExpanded,
    });
  };

  public componentDidMount() {
    this.state = ChromeDayAllDayEvents.getDerivedStateFromProps(this.props, this.state);
  }

  public UNSAFE_componentWillReceiveProps(newProps: IProps, newState: IState) {
    this.state = ChromeDayAllDayEvents.getDerivedStateFromProps(newProps, newState);
  }

  public render() {
    const { eventPositioners, hasPourover, isPouroverExpanded } = this.state;

    if (eventPositioners.length === 0) {
      return null;
    }

    const pouroveredEventPositioners = eventPositioners.slice(
      0,
      isPouroverExpanded ? undefined : 2,
    );
    const pouroverText = `${eventPositioners.length - 2} more`;

    return (
      <div style={styles.mainContainer}>
        <div style={styles.pouroverContainer}>
          {hasPourover ? (
            <IconButton onClick={this.togglePourover}>
              {isPouroverExpanded ? <ExpandLess /> : <ExpandMore />}
            </IconButton>
          ) : null}
        </div>
        <div style={styles.eventsContainer}>
          {pouroveredEventPositioners.map(this.renderEvent)}
          {!isPouroverExpanded ? (
            <Typography
              variant="caption"
              style={styles.pouroverTypography}
              onClick={this.togglePourover}
            >
              {pouroverText}
            </Typography>
          ) : null}
        </div>
      </div>
    );
  }
}
